import styled from "@emotion/styled";
import { Flex } from "@otrium/core";
import { Divider } from "src/atoms/Divider";
import { Heading } from "@otrium/atoms";
import Link from "next/link";

const StyledBrandName = styled.span`
  display: block;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.tone.black};
  margin-top: ${({ theme }) => theme.space[0]}px;

  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: ${({ theme }) => theme.space[5]}px;
  }
`;

const StyledBrandNameLink = styled(Link)`
  font-weight: 700;
  font-style: normal;
  color: ${({ theme }) => theme.colors.tone.black};
  margin-top: ${({ theme }) => theme.space[0]}px;
  margin-bottom: ${({ theme }) => theme.space[0]}px;

  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: ${({ theme }) => theme.space[5]}px;
  }
`;

const StyledProductHeading = styled(Heading)`
  font-family: ${({ theme }) => theme.fonts.body};
`;

const StyledProductName = styled.span`
  display: block;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.tone.black};
  text-transform: lowercase;
  font-weight: 400;
  margin: 8px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin: 4px 0;
  }

  &:first-letter {
    text-transform: capitalize;
  }
`;

const PriceWrapper = styled(Flex)`
  flex-wrap: wrap;
  column-gap: ${({ theme }) => theme.space.space16};
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.fontSize20};
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.tone.black};
  align-items: center;
  margin-bottom: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    font-size: 18px;
  }

  .promo-code {
    display: inline-flex;
    place-items: center;
    font-family: ${({ theme }) => theme.fonts.body};
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    font-weight: ${({ theme }) => theme.fontWeights.body};

    svg {
      width: ${({ theme }) => theme.fontSizes.fontSize14};
      height: ${({ theme }) => theme.fontSizes.fontSize14};
    }
  }
`;

const RegularPrice = styled.span`
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
`;

const AdditionalPrice = styled.span<{ strike?: boolean }>`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.tone.black};
  font-weight: 400;
  text-decoration: ${({ strike }) => (strike ? "line-through" : "none")};
`;
const PriceNoteText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.tone.black};
  font-weight: 400;
  line-height: 16px;
  margin: 0;
`;

const InlineNote = styled.span`
  display: inline;
`;

const VerticalDivider = styled(Divider)`
  width: 1px;
  height: 14px;
  background-color: ${({ theme }) => theme.colors.tone.black};
  display: inline-block;
  vertical-align: middle;
`;

export {
  PriceWrapper,
  RegularPrice,
  AdditionalPrice,
  PriceNoteText,
  StyledBrandName,
  StyledBrandNameLink,
  StyledProductName,
  StyledProductHeading,
  VerticalDivider,
  InlineNote,
};
